<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style>
@import url("~@/assets/fonts/rollgates/stylesheet.css");
@import url("~@/assets/fonts/gotham/stylesheet.css");
</style>
<script>
import "normalize.css";
export default {
  name: "app",
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Đồng hồ nữ Florenge - Bloom in every moment",
    // all titles will be injected into this template
    titleTemplate: "%s | Curnon",
    meta: [
      {
        vmid: "description",
        name: "description",
        content:
          "5 phối màu mang đậm dấu ấn hài hoà giữa cổ điển và hiện đại với mặt đồng hồ được chạm khắc vân Guilloche sẽ là 5 bông hoa luôn nở rộ nhắc bạn tỏa sáng mọi phút giây",
      },
    ],
  },
};
</script>